import axios from '~/api/axios';
import { Person } from '~/types/Person';

export const getContacts = (excludedRole?: any) => {
  return axios.get<any>(`contact/byRole?excludedRoles=${excludedRole}`).then((res) => res.data);
};

export const getCardholderContactId = (phoneNo = '', email?: string) => {
  return axios.get<any>(`contact?email=${email}&phoneNo=${encodeURIComponent(phoneNo)}`).then((res) => res.data);
};

export const mutateContact = (data: any) => {
  return axios.post<any>('contact', data).then((res) => res.data);
};

export const checkMatchingContact = async (data: Person) => {
  const res = await axios.post('contact/matching', data);
  return res.data;
};

export const checkEmailExists = async ({
  contactId,
  email,
  role,
}: {
  contactId: string;
  email: string;
  role: string;
}): Promise<boolean> => {
  const response = await axios.get<boolean>('/contact/checkEmail', {
    params: { contactId, email, role },
  });
  return response.data;
};
